/**
 * Store admin — sampling queue (Commerce, M3).
 *
 * @see apps/web/src/features/store/samples/samples-list-page.tsx
 */
import { createFileRoute } from "@tanstack/react-router";
import { SamplesListPage } from "../../../../../features/store/index.ts";

export const Route = createFileRoute("/(workspace)/store/admin/sampling/")({
  component: SamplesListPage,
});
